import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button, Row, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { USER_PUT_CREDIT_URL } from '../../actions/url';

const propTypes = {
  onCloseClicked: PropTypes.func.isRequired,
  selectedUserId: PropTypes.string,
  selectedMobileUserId: PropTypes.string.isRequired,
};

class EditCreditModal extends Component {
  constructor() {
    super();
    this.state = {
      inputText: '',
      errors: '',
    };
  }

  editCredit = (credit) => {
    let errors = '';

    // check validation
    if (!credit) {
      errors = 'Credit field cannot be empty';
    } else if (!(/[0-9]+/.test(credit))) {
      errors = 'Credit is not valid';
    }

    const data = new FormData();
    data.append('pk', this.props.selectedMobileUserId);
    data.append('credit', credit);
    if (errors === '') {
      axios.post(
        USER_PUT_CREDIT_URL,
        data,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        },
      ).then((response) => {
        if (response.status === 200) {
          alert(`Edit credit to: ${credit}`);
        }
        this.props.onCloseClicked();
        this.setState({
          errors: '',
        });
      })
        .catch((error) => {
          alert('Could not edit credit, please try again!');
        });
    } else {
      this.setState({ errors });
    }
  };

  render() {
    const { inputText, errors } = this.state;
    return (
      <div>
        <Row>
          <div className="text-center" style={{ marginTop: '20px' }}>
            <h3><Translate value="type_in_credit" /></h3>
          </div>
        </Row>
        <Row>
          <div className="col-xs-1 col-xs-offset-3" style={{ textAlign: 'right', paddingRight: '0px' }}>
            +
          </div>
          <div className="col-xs-4">
            <Input
              type="email"
              onChange={event => this.setState({ inputText: event.target.value })}
            />
          </div>
          <div className="col-xs-1 col-xs-offset-5" style={{ marginTop: '50px' }}>
            <Button
              bsStyle="primary"
              onClick={() => { this.editCredit(inputText); }}
            >
              <em className="fa fa-check" /><Translate value="Confirm" />
            </Button>
          </div>
        </Row>
        <br />
        <Row>
          {errors !== '' && <div className="alert alert-danger"><Translate value={errors} /></div>}
        </Row>
      </div>
    );
  }
}

EditCreditModal.propTypes = propTypes;
export default EditCreditModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/EditCreditModal.jsx